import { useCallback, useEffect, useContext, useState } from "react";
import { Typography, Button, Stack, Box, Chip, Fade, Modal, FormControl, InputLabel, Select, MenuItem, CircularProgress } from "@mui/material";

import { TableDataGrid, MyAutocomplete } from "../component/index";
import {
  CustomMyTab,
  CustomMyTabs,
  CustomPaper,
  CustomChip,
  GradientTypography,
  BlackSpan,
  CustomPagination,
} from "../styles/style";

import DataSourceContext from "../context/DataSourceMngContext";
import {
  useGetTransaction,
  useGetTransactionById,useGetAITraining
} from "../services/useTransactionApi";

//huawei
import { columns_huawei, columns_huawei_data } from "./data-source/huawei/table";
import { columns_google_drive } from "./data-source/google-drive/table";
import { columns_onedrive } from "./data-source/onedrive/table";
import { columns_images, columns_images_ai } from "./data-source/images/table";
//icon
import SyncIcon from "@mui/icons-material/Sync";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import { useDempStore } from "src/context/stores";
import useSearchEffect from "../hooks/useSearchEffect";
import { DialogImageAnnotate } from "./modals/dialog-image-annotate";
import DescriptionIcon from '@mui/icons-material/Description';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import DialogNewTraining from "./modals/dialog-new-training";

const Self_upload_type = [
  { display_name: 'Bills', type: 'bill', icon: <DescriptionIcon sx={{ fontSize: 18 }}/>, status: 'Sync' },
  { display_name: 'Water Meters', type: 'water_meter', icon: <CameraAltIcon sx={{ fontSize: 18 }}/>, status: 'Sync' },
  { display_name: 'Waste', type: 'xlsx_csv_waste', icon: <DescriptionIcon sx={{ fontSize: 18 }}/>, status: 'Sync' },
  { display_name: 'Commuting', type: 'xlsx_csv_travelling', icon: <DescriptionIcon sx={{ fontSize: 18 }}/>, status: 'Sync' },
]

const General_model = [
  {
    id: 1,
    name: "General Model",
    value: "general",
  },
  {
    id: 2,
    name: "Fleetcard Model",
    value: "fleetcard",
  }
]

const Water_meter_model = [
  {
    id: 1,
    name: "Water Meter",
    value: "water_meter",
  }
]

const Waste_model = [
  {
    id: 1,
    name: "Waste",
    value: "xlsx-csv-waste",
  }
]

const Commuting_model = [
  {
    id: 1,
    name: "Commuting",
    value: "xlsx-csv-travelling",
  }
]

// Transaction columns configuration
// const columns_transaction = [
//     { field: 'id', headerName: 'ID', width: 90 },
//     {
//         field: 'create_at',
//         headerName: 'Created At',
//         width: 200,
//         align: 'center',
//         headerAlign: 'center',
//         renderCell: (params) => {
//             const date = new Date(params.row.create_at);
//             return (
//             <Typography variant="body1" align="center" padding={2}>
//                 {date.toLocaleDateString()} {date.toLocaleTimeString()}
//             </Typography>
//             );
//         }

//       },
// ];

export default function DeviceDetails() {
  const {
    selectServer,
    self_upload_type,
    status,
    dialog,
    loading,
    overview_status,
    devices,
    paginationModel,
    fetchDevice,
    setDataState,
    setPaginationModel,
    mode,
  } = useContext(DataSourceContext);

  const [query, setQuery] = useState("");
  const [isFetching, setIsFetching] = useState(false);
  const [openNewModal, setOpenNewModal] = useState(false);
  const [selectedType, setSelectedType] = useState("");
  const [openAnnotateModal, setOpenAnnotateModal] = useState(false);
  const [isLoadingAnnotate, setIsLoadingAnnotate] = useState(false);

  //   useEffect(() => {
  //     const handler = setTimeout(() => {
  //       // setDataState((prevState) => ({
  //       //   ...prevState,
  //       //   invoice_id: query,
  //       // }));
  //       setState();
  //     }, 1000);

  //     return () => clearTimeout(handler);
  //   }, [query]);

  const setState = useCallback(() => {
    setDataState((prev) => ({
      ...prev,
      invoice_id: query,
    }));
  }, [query]);

  useSearchEffect({
    callback: setState,
    query,
  });

  useEffect(() => {
    const interval = setInterval(() => {
      const device = devices?.results?.find(
        (item, i) => i === 0 && item.in_progress
      );
      if (device && !isFetching && paginationModel?.page === 0) {
        setIsFetching(true);
        fetchDevice().finally(() => setIsFetching(false));
      }
    }, 30000);
    return () => clearInterval(interval);
  }, [devices, isFetching, paginationModel]);

  const handleUploadTransaction = () => {
    setDataState((prevState) => ({
      ...prevState,
      loading: {
        ...prevState.loading,
        modal: false,
      },
      dialog: {
        ...prevState.dialog,
        upload_transaction: true,
      },
    }));
  };

  const handleNewTransaction = () => {
    setDataState((prevState) => ({
      ...prevState,
      loading: {
        ...prevState.loading,
        modal: false,
      },
      dialog: {
        ...prevState.dialog,
        new_training: true,
      },
    }));
  };

  const handleCloseNewModal = () => {
    setSelectedType("");
    setDataState((prevState) => ({
      ...prevState,
      dialog: {
        ...prevState.dialog,
        new_training: false,
      },
    }));
  };

  const handleTypeSelect = async () => {
    setDataState((prevState) => ({
      ...prevState,
      dialog: {
        ...prevState.dialog,
        new_training: false,
        annotate: true,
      },
    }));
  };

  // const { singleItem: transactions, isLoadingSingleItem: isLoadingTransactions, mutateItem: mutateTransactions } = useGetTransaction(companyId);

  // const [selectedRow, setSelectedRow] = React.useState(null);
  // const [openModal, setOpenModal] = React.useState(false);
  // // const { itemById: transactionDetails, isLoadingItemById } = useGetTransactionById(selectedRow?.id);

  // const handleRowClick = (params) => {
  //     setSelectedRow(params.row);
  //     setOpenModal(true);
  // };

  // const handleCloseModal = () => {
  //     setOpenModal(false);
  //     setSelectedRow(null);
  // };


  const formatThaiDate = (dateString) => {
    if (!dateString) return '';
  
    const date = new Date(dateString);
  
    const thaiMonths = [
      'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน',
      'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม',
      'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
    ];

    const BUDDHIST_ERA = 543;
  
    const day = date.getDate();
    const month = thaiMonths[date.getMonth()];
    const year = date.getFullYear() + BUDDHIST_ERA;
  
    return `${month} ${year}`;
  };
  
  return (
    <CustomPaper sx={{ minHeight: "calc(100vh - 400px)", position: "relative" }}>
      {Boolean(selectServer?.name) ? (
        <Stack spacing={2}>
          {/* Title and Search input */}
          <Box sx={{ display: "flex", justifyContent: "space-between", flexDirection: mode !== 'liff' ? "row" : "column", gap: 2 }}>
            <Stack direction="column" spacing={1}>
              {mode !== 'liff' && (
                <Fade in={true}>
                  <Typography variant="h3">
                    {selectServer?.name}
                    <span style={{ fontSize: "16px" }}>
                      {self_upload_type === 'water_meter' && ` ( ${formatThaiDate(devices.start_date)} - ${formatThaiDate(devices.end_date)} )`}
                    </span>
                  </Typography>
                </Fade>
              )}
              {(
                selectServer?.name === "Self Upload" ||
                selectServer?.name === "Dap Lite"
              ) && (
              <Stack direction="row" spacing={1}>
                {Self_upload_type?.map((item) => (
                  <CustomChip
                    key={item.type}
                    label={item.display_name}
                    status={item.status}
                    // icon={item.icon}
                    isSelected={self_upload_type === item.type}
                    onClick={() => {
                      setDataState((prevState) => ({
                        ...prevState,
                        model: null,
                        loading: {
                          ...prevState.loading,
                          card: true,
                        },
                        devices: {
                          ...prevState.devices,
                          results: [],
                          count: 0,
                        },
                        self_upload_type: item.type,
                        // Select_model: self_upload_type === 'water_meter' ? General_model : Water_meter_model,
                        Select_model: (() => {
                          const type = item.type;
                          if (type === 'water_meter') {
                            return Water_meter_model;
                          } else if (type === 'xlsx_csv_waste') {
                            return Waste_model;
                          } else if (type === 'xlsx_csv_travelling') {
                            return Commuting_model;
                          } else {
                            return General_model;
                          }
                        })(),
                        paginationModel: { page: 0, pageSize: 10 },
                      }));
                    }}
                  />
              ))}
              </Stack>
            )}
            </Stack>
            <Stack direction="row" spacing={1} sx={{ width: mode !== 'liff' ? "30%" : "100%" }}>
              {selectServer?.code === 'huawei' ? <></>: (
                <MyAutocomplete
                  fullWidth
                  value={query}
                  placeholder="Search by invoice id"
                  IsfreeSolo={true}
                  disabled={devices?.length === 0}
                  onInputChange={(event, value) => setQuery(value)}
                />
              )}
              {Boolean(selectServer?.name) && 
              selectServer?.name === "Self Upload" && (
                  <Button
                    variant="contained"
                    size="small"
                    sx={{ width: "130px", height: "38px" }}
                    onClick={handleUploadTransaction}
                  >
                    Upload
                  </Button>
                )}
              {Boolean(selectServer?.name) &&
                  selectServer?.name === "AI Training" &&    <Button
                  variant="contained"
                  size="small"
                  sx={{ width: "130px", height: "38px" }}
                  onClick={() => handleNewTransaction()}
                >
                  New Training
                </Button>}
            </Stack>
          </Box>
          {overview_status?.length > 0 && (
            <CustomMyTabs value={0}>
              {overview_status?.map((t, index) => (
                <CustomMyTab
                  key={index}
                  label={
                    <Box sx={{ textAlign: "start", width: "120px" }}>
                      <Typography variant="body1">{t.display_name}</Typography>
                      <GradientTypography>
                        {t.total} <BlackSpan>Devices</BlackSpan>
                      </GradientTypography>
                    </Box>
                  }
                  icon={t.icon}
                  iconPosition="end"
                />
              ))}
            </CustomMyTabs>
          )}
          {status?.length > 0 && (
            <Stack direction="row" spacing={1} sx={{ width: "30%" }}>
              <Typography variant="caption" sx={{ fontSize: "15px" }}>
                Status:
              </Typography>
              {status?.map((chip) => (
                <CustomChip
                  key={chip.id}
                  label={chip.label}
                  status={chip.label}
                  icon={chip.icon}
                  color={chip.color}
                />
              ))}
            </Stack>
          )}
          <TableDataGrid
            rows={devices?.results || []}
            columns={DataSourceItem(selectServer?.code?.toLowerCase(), self_upload_type)}
            paginationModel={paginationModel}
            setPaginationModel={setPaginationModel}
            rowCount={devices?.count}
            getRowId={(row) => row.id ?? `${row.activity_date}-${row.company_id}-${row.plant_id}-${row.type}`}
          />
          {/* {devices?.results?.length > 24 && ( */}
            <CustomPagination
              count={Math.ceil(devices?.count / 24)}
              page={paginationModel?.page + 1}
              onChange={(event, value) =>
                setPaginationModel({ page: value - 1, pageSize: 24 })
              }
              variant="outlined"
              shape="rounded"
              hidePrevButton
              hideNextButton
            />
          {/* )} */}
        </Stack>
      ) : (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            padding: "2%",
            border: "1px solid #e0e0e0",
            borderRadius: "12px",
            color: "gray",
            fontSize: "14px",
            alignItems: "center",
            minHeight: "calc(100vh - 450px)",
          }}
        >
          No contents
        </Box>
      )}
      {/* {transactions?.results?.length === 0 ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', padding: '2%', border: '1px solid #e0e0e0', borderRadius: "12px", color: "gray", fontSize: '14px', alignItems: 'center', minHeight: 'calc(100vh - 450px)' }}>
                    No contents
                </Box>
            ) : (
                <Stack spacing={2}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Stack direction="row" spacing={2}>
                            <Fade in={true}>
                                <Typography variant="h3">
                                    Transactions
                                </Typography>
                            </Fade>
                        </Stack>
                    </Box>

                    <TableDataGrid
                        rows={transactions?.results || []}
                        columns={columns_transaction}
                        initialState={{ pagination: { page: 0, pageSize: 10 } }}
                        pageSizeOptions={[5, 10]}
                        onRowClick={handleRowClick}
                    />

                    <Modal
                        open={openModal}
                        onClose={handleCloseModal}
                        aria-labelledby="transaction-details-modal"
                    >
                        <Box sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            width: 400,
                            bgcolor: 'background.paper',
                            boxShadow: 24,
                            p: 4,
                            borderRadius: 2,
                        }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                                <Typography variant="h6" component="h2" gutterBottom>
                                    Transaction Details
                                </Typography>
                                <IconButton 
                                    onClick={handleCloseModal}
                                    sx={{ 
                                        position: 'absolute',
                                        right: 8,
                                        top: 8,
                                        color: 'gray'
                                    }}
                                >
                                    <CloseIcon />
                                </IconButton>
                            </Box>
                            {selectedRow && (
                                <Stack spacing={2}>
                                     <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                        <thead>
                                            <tr>
                                                <th className='text-black p-2'>Emission Date</th>
                                                <th className='text-black p-2'>Status</th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {transactionDetails?.details?.map((item) => (
                                                <tr key={item.id}>
                                                    <td style={{ padding: '8px', borderBottom: '1px solid #ddd' }}>
                                                        {item.emission_date ? new Date(item.emission_date).toLocaleDateString() : '-'}
                                                    </td>
                                                    <td style={{ padding: '8px', borderBottom: '1px solid #ddd', textAlign: 'center' }}>
                                                        {item.status === 'success' ? (
                                                            <CheckIcon color="success" />
                                                        ) : (
                                                            <CloseIcon color="error" />
                                                        )}
                                                    </td>
                                                
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>

                                </Stack>
                            )}
                        </Box>
                    </Modal>
                </Stack>
            )} */}

      {/* New Transaction Modal */}
      <Modal
        open={openNewModal}
        onClose={handleCloseNewModal}
        aria-labelledby="new-transaction-modal"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}>
          {/* Loading Overlay */}
          {isLoadingAnnotate && (
            <Box sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              bgcolor: 'rgba(255, 255, 255, 0.8)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: 2,
              zIndex: 1,
            }}>
              <Box sx={{ textAlign: 'center' }}>
                <CircularProgress size={40} />
                <Typography variant="body2" sx={{ mt: 1 }}>
                  Loading annotation data...
                </Typography>
              </Box>
            </Box>
          )}
          
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
            <Typography variant="h6" component="h2" gutterBottom>
              Select type
            </Typography>
            <Button 
              onClick={handleCloseNewModal}
              disabled={isLoadingAnnotate}
              sx={{ 
                position: 'absolute',
                right: 8,
                top: 8,
                color: 'gray'
              }}
            >
              <CloseIcon />
            </Button>
          </Box>
          
          <Stack spacing={3}>
            <FormControl fullWidth>
              <InputLabel id="type-select-label">Select type</InputLabel>
              <Select
                labelId="type-select-label"
                id="type-select"
                value={selectedType}
                label="Select type"
                onChange={(e) => setSelectedType(e.target.value)}
                disabled={isLoadingAnnotate}
              >
                {selectServer?.option?.map((option) => (
                  <MenuItem key={option.code} value={option.code}>
                    {option.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 2 }}>
              <Button 
                variant="outlined" 
                onClick={handleCloseNewModal}
                disabled={isLoadingAnnotate}
              >
                Cancel
              </Button>
              <Button 
                variant="contained" 
                onClick={handleTypeSelect}
                disabled={!selectedType || isLoadingAnnotate}
                startIcon={isLoadingAnnotate ? <CircularProgress size={16} color="inherit" /> : null}
              >
                {isLoadingAnnotate ? 'Loading...' : 'Confirm'}
              </Button>
            </Box>
          </Stack>
        </Box>
      </Modal>
      {/* DialogNewTraining Modal */}
      <DialogNewTraining />

      {/* DialogImageAnnotate Modal */}
      {selectServer?.code === 'ai_training' && (
      <DialogImageAnnotate
        open={dialog.annotate}
        onClose={() => {
          setDataState((prevState) => ({
            ...prevState,
            dialog: {
              ...prevState.dialog,
              annotate: false,
            },
          }));
        }}
      />
      )}

      {loading?.card && (
        <Box sx={{ 
          position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,     backgroundColor: 'rgba(255, 255, 255, 0.4)',
          borderRadius: "12px",
          backdropFilter: 'blur(2px)',
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          WebkitBackdropFilter: 'blur(2px)', // สำหรับ Safari
          zIndex: 1 }}>
            <CircularProgress size={80} />
        </Box>
      )}
    </CustomPaper>
  );
}

function DataSourceItem(status, type) {
  switch (status) {
    case "api":
      return columns_images;
    case "sat":
      return columns_huawei;
    case "iot":
      return columns_onedrive;
    case "database":
      return columns_onedrive;
    case "huawei":
      return columns_huawei_data;
    case "onedrive":
    case "one_drive":
    case "One Drive":
      return columns_onedrive;
    case "google_drive":
      return columns_google_drive;
    case "self_upload":
      return  columns_images?.filter((item) => {
        if (type === 'water_meter') {
          return item.field !== 'bill_type' && item.field !== 'in_progress';
        }else if(type === 'xlsx_csv_waste') {
          return item.field !== 'bill_type' && item.field !== 'model';
        } else if(type === 'xlsx_csv_travelling') {
          return item.field !== 'bill_type' && item.field !== 'model';
        }
        return true;
      }).map((item) => {
        if (item.field === 'id' && type === 'water_meter') {
          return {
            ...item,
            field: 'item_sort',
          }
        }
        return item;
      })
    case "dap_lite":
      return columns_images?.filter((item) => {
        if (type === 'water_meter') {
          return item.field !== 'bill_type';
        }
        return true;
      });
    case "ai_training":
      return columns_images_ai;
    case undefined:
      return [];
    default:
      return [];
  }
}
